// Атрибуты словарной практики. Как у карточек и квизов, бэкенд опознаёт практику по
// тройке practiceType/practiceFormat/learningMethod, поэтому значения обязаны совпадать
// у сводки по колоде, инициализации практики и её прохождения.
export const WORD_PRACTICE_TYPE = 'WORD';
export const WORD_LEARNING_METHOD = 'FIXED_SCHEDULE';

// Форматы словарной практики в порядке показа на странице выбора.
export const WORD_PRACTICE_FORMATS = [
    { format: 'SELF_ASSESSMENT', titleKey: 'practice.selfAssessment', descriptionKey: 'practice.formatDescription.selfAssessment' },
    { format: 'SPELLING_FROM_AUDIO', titleKey: 'practice.spelling', descriptionKey: 'practice.formatDescription.spelling' },
    { format: 'SENTENCE_BUILDING_FROM_WORD', titleKey: 'practice.sentenceBuilding', descriptionKey: 'practice.formatDescription.sentenceBuilding' },
    { format: 'ORIGINAL_TO_TRANSLATION', titleKey: 'practice.chooseTranslation', descriptionKey: 'practice.formatDescription.chooseTranslation' },
    { format: 'TRANSLATION_TO_ORIGINAL', titleKey: 'practice.chooseHeadword', descriptionKey: 'practice.formatDescription.chooseHeadword' },
];

// Карточки всех форматов написаны только под британский английский; под остальные
// языки есть одна самооценка. Страница выбора обязана предлагать ровно те форматы,
// которые страница прохождения умеет показать: раньше она рисовала все пять для любого
// языка, и четыре карточки из пяти вели в одну и ту же самооценку.
const FULL_FORMAT_LOCALES = new Set(['ENGLISH_GB']);

export const wordPracticeFormatsFor = (localeCode) =>
    FULL_FORMAT_LOCALES.has(localeCode)
        ? WORD_PRACTICE_FORMATS
        : WORD_PRACTICE_FORMATS.filter(({ format }) => format === 'SELF_ASSESSMENT');
